import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import "./index.css";

import TopDealsCard from "./TopDealsCard";

const TopDeals = ({ t, vendor_name }) => {
  const [topDealsProducts, setTopDealsProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/top-deal?vendor_name=${vendor_name}`)
      .then((response) => response.json())
      .then((data) => {setTopDealsProducts(data); setLoading(false);});
  }, [vendor_name]);

  let productsToShow = (
    <div className="loading-container">
      <div className="loading-spinner deals-spinner"></div>
      <h3>Finding Best Deals...</h3>
    </div>
  );
  
  let heading = (
    <div className="deals-header">
      <div className="deals-badge">🔥 HOT DEALS</div>
      <h1 className="deals-title">{t("TopDeals") || "Top Deals"}</h1>
      <div className="deals-subtitle">Limited time offers - Grab them before they're gone!</div>
      <div className="deals-timer">
        <span className="timer-text">Deals end in:</span>
        <div className="timer-display">
          <div className="timer-unit">
            <span className="timer-number">23</span>
            <span className="timer-label">Hours</span>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-unit">
            <span className="timer-number">59</span>
            <span className="timer-label">Minutes</span>
          </div>
        </div>
      </div>
    </div>
  );

  if (topDealsProducts.length) {
    productsToShow = topDealsProducts.slice(0, 20).map((product, index) => (
      <div key={product.id || index} className="deal-item">
        <TopDealsCard
          productObj={product}
          title={product.name}
          price={`৳${product.price}`}
          image={product.photo}
          t={t}
          dealIndex={index}
        />
      </div>
    ));
  } else if(!loading) {
    productsToShow = (
      <div className="no-deals-container">
        <div className="no-deals-icon">💸</div>
        <h3>No Active Deals</h3>
        <p>Check back soon for amazing offers!</p>
      </div>
    );
  }

  return (
    <section className="top-deals-section">
      <div className="deals-background">
        <div className="deals-pattern"></div>
      </div>
      <div className="container">
        {heading}
        <div className="deals-grid">
          {productsToShow}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps=(state)=> {
  return {
    vendor_name: state.globalState.selectedProductVendorName,
  }
}

const mapDispatchToProps={}

export default connect(mapStateToProps, mapDispatchToProps)(TopDeals);